export const FETCH_ADD_RETURN_DATA_REQUEST =
  'returns/fetch-add-return-data-request';
export const FETCH_ADD_RETURN_DATA_PRE_SUCCESS =
  'returns/fetch-add-return-data-pre-success';
export const FETCH_ADD_RETURN_DATA_RATES_SUCCESS =
  'returns/fetch-add-return-data-rates-success';
export const FETCH_ADD_RETURN_DATA_POST_SUCCESS =
  'returns/fetch-add-return-data-post-success';
export const FETCH_ADD_RETURN_DATA_FAILURE =
  'returns/fetch-add-return-data-failure';
export const SAVE_MAPPING_REQUEST = 'returns/save-mapping-request';
export const SAVE_MAPPING_SUCCESS = 'returns/save-mapping-success';
export const SAVE_MAPPING_FAILURE = 'returns/save-mapping-failure';
export const DELETE_MAPPING_REQUEST = 'returns/delete-mapping-request';
export const DELETE_MAPPING_SUCCESS = 'returns/delete-mapping-success';
export const DELETE_MAPPING_FAILURE = 'returns/delete-mapping-failure';

export const RESET_RETURN_DATA = 'returns/reset-return-data';

// New standalone getReturnTypes constants
export const FETCH_RETURN_TYPES_REQUEST = 'returns/fetch-return-types-request';
export const FETCH_RETURN_TYPES_SUCCESS = 'returns/fetch-return-types-success';
export const FETCH_RETURN_TYPES_FAILURE = 'returns/fetch-return-types-failure';

// Default Tax Rates constants
export const FETCH_DEFAULT_TAX_RATES_REQUEST =
  'returns/fetch-default-tax-rates-request';
export const FETCH_DEFAULT_TAX_RATES_SUCCESS =
  'returns/fetch-default-tax-rates-success';
export const FETCH_DEFAULT_TAX_RATES_FAILURE =
  'returns/fetch-default-tax-rates-failure';
export const MAP_TAX_RATES_TO_BOXES = 'returns/map-tax-rates-to-boxes';
export const MAP_TAX_RATES_TO_BOXES_FAILURE =
  'returns/map-tax-rates-to-boxes-failure';
export const RESET_AI_MAPPING_STATUS = 'returns/reset-ai-mapping-status';
export const SET_TAX_RATES_TO_BOXES_MAPPING =
  'returns/set-tax-rates-to-boxes-mapping';
